// @ts-nocheck
import React, { ReactElement } from 'react'
import { isInApp } from '../../utils/utils'
import cs from 'classnames'
import './index.scss'

interface FontFamilyProps {
  className?: string
  children?: ReactElement
}

const FontFamily = (props: FontFamilyProps): ReactElement => {
  const { children, className } = props
  return (
    <div
      className={cs(className, {
        'design-system-in-app': isInApp(),
      })}
    >
      {children}
    </div>
  )
}

export default FontFamily
